import React from 'react';

const ProjectFilter = ({
  projects,
  selectedProject,
  onSelectProject,
  onRefresh,
}) => {
  return (
    <div className="flex items-center justify-between rounded px-1 py-2 bg-gray-50 mt-1">
      <select
        className="text-sm font-medium bg-transparent outline-none"
        value={selectedProject || ''}
        onChange={(e) =>
          onSelectProject(e.target.value ? Number(e.target.value) : null)
        }
      >
        <option value="">All Projects</option>
        {projects.map((project) => (
          <option key={project.id} value={project.id}>
            {project.name}
          </option>
        ))}
      </select>
      <button
        className="p-1 hover:bg-gray-100 rounded"
        onClick={onRefresh}
        aria-label="Refresh chats"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5 text-gray-600"
          viewBox="0 0 20 20"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path
            d="M4 4V9H4.58152M19.9381 11C19.446 14.8599 16.1789 18 12 18C7.82107 18 4.55402 14.8599 4.06189 11M4.06189 11H8M15.9685 1C12.0615 1.86364 8.91411 5.03636 7.85379 9"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </div>
  );
};

export default ProjectFilter;
